import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getUserInterviews } from './actions'
import * as userInterviewsSelectors from './selectors'
import UserInterviewsPage from './containers/UserInterviewsPage'

function UserInterviews() {
  const dispatch = useDispatch()
  const regularInterviews = useSelector(userInterviewsSelectors.regularInterviews)
  const avaInterviews = useSelector(userInterviewsSelectors.avaInterviews)
  const isLoading = useSelector(userInterviewsSelectors.isLoading)
  const error = useSelector(userInterviewsSelectors.error)

  useEffect(() => {
    dispatch(getUserInterviews())
  }, [dispatch])

  return (
    <UserInterviewsPage
      regularInterviews={regularInterviews}
      avaInterviews={avaInterviews}
      isLoading={isLoading}
      error={error}
    />
  )
}

export default UserInterviews


